import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './shared/modal';
import ConfirmRemoveDialog from './ConfirmRemoveDialog';
import { upsertCategory, removeCategory } from '../services/categories';

const CategoryDialogButton = ({ category, onChange }) => {
  const { t } = useTranslation();
  const [data, setData] = useState({title: ''});
  const [show, setShow] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { category && setData({...category})}, [category]);

  const save = async () => {
    if (!data?.title.trim()) return;
    setLoading(true)
    try {
      const result = await upsertCategory(data);
      onChange && onChange(result.category);
      closeModal();
    } catch (e) {
      setLoading(false)
    }
  };

  const confirmRemove = async () => {
    setLoading(true)
    await removeCategory(category.id);
    closeModal()
  };

  const closeModal = () => {
    setLoading(false)
    setShow(false);
    setData({title: ''})
  };

  return (
    <div className="form-container-content-right-narrow">
      <button className="button button-add button-category mr10" onClick={() => setShow(true)}>
        + {t('categories.add')}
      </button>

      <Modal openModal={show} closeModal={closeModal}>
        <div className="category-dialog">
          <h4>{!category?.id ? t('categories.add') : t('categories.edit')}</h4>
          <div className="dialog-content">

            <div className="form-group">
              <label htmlFor="groupName">{t('common.title')}</label>
              <input
                type="text"
                value={data.title}
                onChange={(e) => setData({...data, title: e.target.value})}
              />
            </div>  
          </div>
        </div>

        <div className='form-container-actions'>
          { category?.id && <button className="button button-delete" onClick={showRemove(true)}>{t('buttons.common.delete')}</button> }
          <div className='flex-end'>
            <button className="button" disabled={loading} onClick={() => closeModal(false)}>{t('buttons.common.cancel')}</button>
            <button className="button button-primary" disabled={loading} onClick={() => save(true)}>{t('buttons.common.save')}</button>
          </div>
        </div>
      </Modal>

      {showRemove && (
        <ConfirmRemoveDialog
          title={t('buttons.common.delete')}
          confirm={confirmRemove}
          close={() => setShowRemove(null)}
        />
      )}
    </div>
  );
};

export default CategoryDialogButton;

